<script setup lang="ts">
// Botão "ID: #..." do Header V2 — mesma marcação usada idêntica no mobile e
// no desktop; extraído pra não duplicar entre as duas seções do Header.vue.
type Props = {
  userId: number | string;
  copied?: boolean;
  // 'default' = pill com borda (desktop, inalterado).
  // 'mobile' = texto puro em negrito, sem borda/fundo, "ID #123" sem
  // dois-pontos (redesign mobile aprovado pelo UX, Figma node
  // 23441:104892/104909) — só o mobile pediu isso.
  variant?: 'default' | 'mobile';
};

const { variant = 'default' } = defineProps<Props>();

const emit = defineEmits<{ copy: [] }>();
</script>

<template>
  <button
    v-if="variant === 'mobile'"
    class="flex items-center gap-[5px] text-[12.75px] font-bold leading-[17px] text-white/[0.55]"
    @click="emit('copy')"
  >
    {{ copied ? 'ID copiado!' : `ID #${userId}` }}
    <!-- ícone próprio (não é o UserV2Icon "copy" — este é o glifo real de
         duas folhas sobrepostas do Figma, não o quadrado simples) -->
    <svg
      class="shrink-0"
      fill="none"
      height="11"
      viewBox="0 0 15 15"
      width="11"
    >
      <path
        d="M10.9286 5.46436H6.67864C6.00801 5.46436 5.46436 6.00801 5.46436 6.67864V10.9286C5.46436 11.5993 6.00801 12.1429 6.67864 12.1429H10.9286C11.5993 12.1429 12.1429 11.5993 12.1429 10.9286V6.67864C12.1429 6.00801 11.5993 5.46436 10.9286 5.46436Z"
        stroke="#7CC0FF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.15357"
      />
      <path
        d="M3.03564 9.10725V3.03582C3.03564 2.71377 3.16358 2.40491 3.3913 2.17719C3.61902 1.94947 3.92788 1.82153 4.24993 1.82153H9.10707"
        stroke="#7CC0FF"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.15357"
      />
    </svg>
  </button>
  <button
    v-else
    class="flex items-center gap-[5px] rounded-[7px] border border-v2-blue-light px-[6px] py-[5px] text-[10px] font-medium leading-[10px] text-white"
    @click="emit('copy')"
  >
    {{ copied ? 'ID copiado!' : `ID: #${userId}` }}
    <!-- !important necessário: tailwind.config.js tem `important: true`,
         então o size-[20px] fixo do Icon.vue já compila com !important — um
         style inline sem !important perde pra ele. -->
    <UserV2Icon
      class="text-v2-blue-light"
      name="copy"
      style="width: 9px !important; height: 10px !important"
    />
  </button>
</template>
